import { render } from "./PrintDelivery2SOnline.vue?vue&type=template&id=78806bd2&scoped=true"
import script from "./PrintDelivery2SOnline.vue?vue&type=script&lang=js"
export * from "./PrintDelivery2SOnline.vue?vue&type=script&lang=js"

import "./PrintDelivery2SOnline.vue?vue&type=style&index=0&id=78806bd2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-78806bd2"

export default script